import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { editUser } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';
import { isEmail, isPasswordValid, isRequired } from 'forms/utils/validators';

const fields: FieldsDefinitions = [
  {
    name: 'password',
    label: editUser.password,
    bindings: 'TextField',
    type: 'password',
    value: '',
    validators: [isPasswordValid],
  },
  {
    name: 'email',
    label: editUser.email,
    bindings: 'TextField',
    value: '',
    validators: [isRequired, isEmail],
  },
  {
    name: 'enabled',
    label: editUser.enabled,
    bindings: 'Checkbox',
    value: true,
  },
  {
    name: 'internal',
    label: editUser.internal,
    bindings: 'Checkbox',
    value: true,
  },
  {
    name: 'admin',
    label: editUser.admin,
    bindings: 'Checkbox',
    value: false,
  },
];

export function createForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
